import React from 'react';
import styled from '@emotion/styled';
import type { SpaceProps } from 'styled-system';
import { themeGet } from 'styled-system';

import type { PropsWithRequiredChildren } from '../types/React';
import { Flex } from './Flex';

interface SeparatorWithTextProps extends PropsWithRequiredChildren, SpaceProps {
  className?: string;
}

const Separator = styled(Flex)`
  &::before,
  &::after {
    display: block;
    content: '';
    flex: 1;
    border: 0;
    border-bottom-width: 1px;
    border-style: solid;
    border-color: ${themeGet('colors.sys.neutral.border.weak')};
  }

  &::before {
    margin-right: ${themeGet('space.sp_12')}px;
  }

  &::after {
    margin-left: ${themeGet('space.sp_12')}px;
  }
`;

const SeparatorWithText = ({ children, className, ...spaceProps }: SeparatorWithTextProps) => (
  <Separator
    my="sp_20"
    role="separator"
    textAlign="center"
    alignItems="center"
    className={className}
    {...spaceProps}
  >
    {children}
  </Separator>
);

export default SeparatorWithText;
